/**
 * LIPShape enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file LIPShape.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum LIPShape {
  EE    = 0, /* LABEL: ee (teeth) */
  EH    = 1, /* LABEL: eh (bet, red) */
  SCHWA = 2, /* LABEL: schwa (a in sofa) */
  AH    = 3, /* LABEL: ah (bat, cat) */
  OH    = 4, /* LABEL: oh (or, boat) */
  OOH   = 5, /* LABEL: oo (blue) wh in wheel */
  Y     = 6, /* LABEL: y (you) */
  S     = 7, /* LABEL: s, ts */
  FV    = 8, /* LABEL: f, v */
  NNG   = 9, /* LABEL: n, ng */
  TH    = 10,/* LABEL: th */
  MBP   = 11,/* LABEL: m, p, b */
  TD    = 12,/* LABEL: t, d */
  SH    = 13,/* LABEL: j, sh */
  LR    = 14,/* LABEL: l, r */
  KG    = 15,/* LABEL: k, g */
}
